// @ts-expect-error
import type {OptionProps} from 'react-select';

import {colors} from 'shells/colors/colors';

export function styleOptionForEntityType(base: any, state: OptionProps) {
    // Set option color based on entity type
    let color = base.color;
    if (state.data.type === 'accounts') {
        color = colors.textAccounts;
    } else if (state.data.type === 'contacts') {
        color = colors.textContacts;
    } else if (state.data.type === 'users') {
        color = colors.textUsers;
    }

    return {
        ...base,
        color,
    };
}
